import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import logo from "../Assets/3d.png";
import { myCustomTheme } from "../Theme";
import "../Style/Navbar.css";

const Navbar = () => {
  const routes = useSelector((state) => state.routes);
  const theme = myCustomTheme;

  const [menuOpen, setMenuOpen] = useState(false);

  const socialIcons = [
    { icon: <FaFacebookF />, href: "https://www.facebook.com/profile.php?id=61593308470964" },
    { icon: <FaInstagram />, href: "https://www.instagram.com/layerstech_3d/" },
    { icon: <FaYoutube />, href: "www.youtube.com/@layerstech3d" },
    { icon: <FaXTwitter />, href: "https://x.com/layerstech3D" },
  ];

  return (
    <header
      className="navbar"
      style={{
        backgroundColor: theme.colors.header_footer_bg,
        padding: theme.spacing.navbar_padding,
        fontFamily: theme.typography.heading_font,
      }}
    >
      <div className="container">

        {/* LOGO */}
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </div>

        {/* MOBILE MENU BUTTON */}
        <div
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* NAV LINKS */}
        <div className={`navbar-links ${menuOpen ? "active" : ""}`}>
          {routes.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              onClick={() => setMenuOpen(false)}
              style={{
                color: theme.colors.menu_text,
                fontFamily: theme.typography.heading_font,
                margin: `0 ${theme.spacing.menu_gap}`,
                textDecoration: "none",
                fontSize: theme.typography.menu_size,
              }}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* SOCIAL ICONS */}
        <div className="navbar-social">
          {socialIcons.map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: theme.colors.icon_color,
                fontSize: theme.typography.icon_size,
                marginLeft: theme.spacing.social_gap,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: theme.spacing.icon_size,
                height: theme.spacing.icon_size,
                boxShadow: theme.shadows.icon_box,
                border: `1px solid ${theme.colors.icon_border}`,
                transition: "all 0.3s ease",
              }}
            >
              {item.icon}
            </a>
          ))}
        </div>

      </div>
    </header>
  );
};

export default Navbar;